import { GetWindow } from "@pdfking/capability"
import { ToCmyk } from "@pdfking/math"
import { Items, RecordCreate } from "@pdfking/tfunc"

import { Default } from "#constants"
import type { Palette } from "#internal"
import { CssColor } from "#internal"

/** The palette the page's CSS sets in `--palette-paper`, `--palette-text`,
 * `--palette-lines`, `--palette-primary`, `--palette-secondary` and
 * `--palette-spot` on its root, any color CSS reads, converted to the CMYK it
 * prints in; each one unset, or set to no color, or with no page to read it
 * from (a worker), is {@link Default}'s. Read anew at every call, so a theme
 * switch shows in the next page drawn. */
export const CssPalette = (): Palette => {
  const window = GetWindow()
  const style = window?.getComputedStyle(window.document.documentElement)
  return RecordCreate(
    Items(Default).map(([key, fallback]) => {
      const value = style?.getPropertyValue(`--palette-${key}`).trim()
      const color = value && CssColor(value)
      return [key, color ? ToCmyk(color) : fallback]
    })
  ) as Palette
}
